import {
  CLEAR_CART,
  PanierActions,
  REMOVE_LINE,
  UPDATE_FRAIS_PORT,
  UPDATE_NGO_CONTRIBUTION,
  UPDATE_PANIER,
  UPDATE_PRODUCT_QUANTITY
} from '../actions/panier.actions';
import { initialFraisPort, PanierState } from '../../types/panier/panier.def';
import { removeLineParams } from '../../helpers/panier/removeLineParams';
import {
  sanitizeCalul,
  multiply,
  toNumber
} from '../../helpers/number/sanitizeCalul';
import { GET_FRAIS_PORT } from '../../domain/commande/getFraisPort';
import { getNgoContributionForPanier } from '../../domain/commande/getOngContribution';

const initalState: PanierState = {
  totalPanier: 0,
  contributionOng: {
    isContributing: false,
    amount: 0
  },
  fraisPort: initialFraisPort,
  commandeLines: []
};

const panierReducer = (
  state: PanierState = initalState,
  action: PanierActions
) => {
  switch (action.type) {
    case UPDATE_PANIER: {
      let updatedCommandeLines = state.commandeLines;
      const indexOfSameCML = state.commandeLines.findIndex(
        cml => cml.produit.id === action.payload.produit.id
      );

      if (indexOfSameCML >= 0)
        updatedCommandeLines[indexOfSameCML] = {
          ...updatedCommandeLines[indexOfSameCML],
          quantite:
            updatedCommandeLines[indexOfSameCML].quantite +
            action.payload.quantite,
          totalLine:
            updatedCommandeLines[indexOfSameCML].totalLine +
            action.payload.totalLine
        };
      if (updatedCommandeLines.length === 0 || indexOfSameCML < 0)
        updatedCommandeLines = [...state.commandeLines, action.payload];
      return {
        ...state,
        totalPanier: sanitizeCalul(
          state.totalPanier + action.payload.totalLine
        ),
        commandeLines: updatedCommandeLines
      };
    }
    case UPDATE_PRODUCT_QUANTITY: {
      const indexOfSameCML = state.commandeLines.findIndex(
        cml => cml.produit.id === action.payload.productId
      );
      const updatedCommandeLines = state.commandeLines;
      let updatedTotalPanier = state.totalPanier;

      if (indexOfSameCML >= 0) {
        const totalLine = updatedCommandeLines[indexOfSameCML].totalLine;
        const newTotalLine = multiply(
          updatedCommandeLines[indexOfSameCML].produit.ttcPrice
        )(action.payload.quantity);

        updatedCommandeLines[indexOfSameCML] = {
          ...updatedCommandeLines[indexOfSameCML],
          quantite: toNumber(action.payload.quantity),
          totalLine: multiply(
            updatedCommandeLines[indexOfSameCML].produit.ttcPrice
          )(action.payload.quantity)
        };

        updatedTotalPanier = sanitizeCalul(
          updatedTotalPanier - totalLine + newTotalLine
        );
      }

      return {
        ...state,
        totalPanier: updatedTotalPanier,
        commandeLines: updatedCommandeLines
      };
    }
    case UPDATE_NGO_CONTRIBUTION: {
      return {
        ...state,
        contributionOng: {
          isContributing: action.payload,
          amount: getNgoContributionForPanier(action.payload)
        }
      };
    }
    case UPDATE_FRAIS_PORT:
      return {
        ...state,
        fraisPort: {
          ...state.fraisPort,
          applicable: action.payload,
          montant: GET_FRAIS_PORT(state.totalPanier, action.payload)
        }
      };
    case CLEAR_CART:
      return initalState;
    case REMOVE_LINE:
      return removeLineParams(state, action.payload);
    default:
      return state;
  }
};

export default panierReducer;
